// src/App.js
import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Layout from "./components/Layout";
import ScrollToTop from "./components/ScrollToTop";
import LanguageRedirect from "./components/LanguageRedirect";
import "./i18n/config";
import About from "./pages/About";
// 페이지 컴포넌트들
import Home from "./pages/Home";
import Games from "./pages/Games";
import Careers from "./pages/Careers";
import Policies from "./pages/Policies";
import Privacy from "./pages/Privacy";
import Cookies from "./pages/Cookies";
import ServicePolicy from "./pages/ServicePolicy";
import YouthPolicy from "./pages/YouthPolicy";
import Upp from "./pages/Upp";
import OurCulture from "./pages/OurCulture";
import LifeAtEdge from "./pages/LifeAtEdge";
import Benefits from "./pages/Benefits";
import JoinUs from "./pages/JoinUs";
import TPB from "./pages/TPB";
import NotFound from "./pages/NotFound";

import "./studio.css";

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <LanguageRedirect />
      <Routes>
        {/* 언어 파라미터가 없는 경우 영어로 리다이렉트 */}
        <Route path="/" element={<Navigate to="/en" replace />} />
        <Route path="/:lang" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="about" element={<About />} />
          <Route path="games" element={<Games />} />
          <Route path="careers" element={<Careers />} />
          <Route path="policies" element={<Policies />} />
          <Route path="privacy" element={<Privacy />} />
          <Route path="cookies" element={<Cookies />} />
          <Route path="youthpolicy" element={<YouthPolicy />} />
          <Route path="servicepolicy" element={<ServicePolicy />} />
          <Route path="upp" element={<Upp />} />
          <Route path="our-culture" element={<OurCulture />} />
          <Route path="life-at-edge" element={<LifeAtEdge />} />
          <Route path="benefits" element={<Benefits />} />
          <Route path="join-us" element={<JoinUs />} />
          <Route path="tpb" element={<TPB />} />
          <Route path="*" element={<NotFound />} />
        </Route>
        {/* 언어 파라미터 없이 접근한 경우 영어로 리다이렉트 */}
        <Route path="/about" element={<Navigate to="/en/about" replace />} />
        <Route path="/company" element={<Navigate to="/en/company" replace />} />
        <Route path="/games" element={<Navigate to="/en/games" replace />} />
        <Route path="/careers" element={<Navigate to="/en/careers" replace />} />
        <Route path="/policies" element={<Navigate to="/en/policies" replace />} />
        <Route path="/privacy" element={<Navigate to="/en/privacy" replace />} />
        <Route path="/cookies" element={<Navigate to="/en/cookies" replace />} />
        <Route path="/youthpolicy" element={<Navigate to="/en/youthpolicy" replace />} />
        <Route path="/servicepolicy" element={<Navigate to="/en/servicepolicy" replace />} />
        <Route path="/upp" element={<Navigate to="/en/upp" replace />} />
        <Route path="/our-culture" element={<Navigate to="/en/our-culture" replace />} />
        <Route path="/life-at-edge" element={<Navigate to="/en/life-at-edge" replace />} />
        <Route path="/benefits" element={<Navigate to="/en/benefits" replace />} />
        <Route path="/join-us" element={<Navigate to="/en/join-us" replace />} />
        <Route path="/tpb" element={<Navigate to="/en/tpb" replace />} />
        <Route path="*" element={<Navigate to="/en" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
